$.fn.extend
  appObject: (options) ->
    input = 
        dropTarget: "page"
        afterDrop: false
    

    input = $.extend input, options

    # console.log settings.frames

    element = $(@)
    dragged = false

    helper = $('#helper')

    move = (event) ->
        
        event.preventDefault()

        
        if element.attr('dragged') == 'true'

            event.preventDefault()
            event.stopPropagation()
            # event.dataTransfer.effectAllowed = 'move'
            # event.dataTransfer.dropEffect = 'move'


            changeX = event.pageX - element.data('mouseX')
            changeY = event.pageY - element.data('mouseY')
            offset = helper.offset();

            # helper = helper.offset();

            helper.offset 
                left: offset.left + changeX
                top: offset.top + changeY

            if event.clientY < 50
                y = $(window).scrollTop()
                $(document).scrollTop(y - 18)

            if event.clientY > $(window).height() - 50
                y = $(window).scrollTop()
                $(document).scrollTop(y + 18)


            element.data 'mouseX', event.pageX
            element.data 'mouseY', event.pageY


        return

    
    output = {
    
        init: () ->

            console.log 'init'



        draggable: ->

            element.addTouch()

            # element.mouseout(move)         
            $(document).mousemove(move)      
            
            element.mousedown (event) ->
                event.preventDefault()
                event.stopPropagation()
                # event.dataTransfer.effectAllowed = 'move';
                # event.dataTransfer.dropEffect = 'move';
                # shapy dycky taham, backgroundy a layouty jenom na prehledu
                if $('#page_detail').length && !element.hasClass('shape') && !element.hasClass('photo')
                    page = $('#page_detail').data 'page_number'
                    if element.data('layout_id') > 0 && element.hasClass('layout') && !element.hasClass('inactive')
                        layoutContainer.change_layout(element.data('layout_id'), page)
                    if element.data('background_id') >= 0 && element.hasClass 'background'
                        backgroundsContainer.change_background(element.data('background_id'), page)
                else
                # element.parent().css('overflow', 'visible')
                    dragged = true

                    helper.show()
                    console.log event.pageX - element.offset().left, event.pageY - element.offset().top
                    # console.log event.pageY,element.offset().top
                    helper.css
                        top: event.pageY  - (event.pageY - element.offset().top)
                        left: event.pageX - (event.pageX - element.offset().left) + 20
                        width: element.width()
                        height: element.height()

                    helper.html(element.html())

                    element.addClass 'dragged'


                    # $('#drag_helper').show()
                    element.css 'z-index', 10000
                    element.css 'opacity', 0.5
                    element.attr 'dragged', true
                    element.data 'mouseX', event.pageX
                    element.data 'mouseY', event.pageY                       


            $(document).mouseup (event) ->
                # event.preventDefault()

                if dragged

                    element.removeClass 'dragged'


                    helper.hide()
                    # console.log element
                    # console.log helper
                    # console.log 'helper mouseup'

                    drop_x = event.pageX
                    drop_y = event.pageY

                    drop_target = null

                    $(input.dropTarget).each ->
                        frame_x = $(@).offset().left
                        frame_y = $(@).offset().top
                        frame_width = $(@).outerWidth()
                        frame_height = $(@).outerHeight()

                        # console.log frame_x, frame_y, drop_x, drop_y, frame_width, frame_height
                        console.log 'DROOOOP'
                        console.log $(@)
                        
                        if drop_x > frame_x && drop_x < frame_x+frame_width && drop_y > frame_y && drop_y < frame_y+frame_height
                            
                            if !$(@).hasClass('calendarium') && !$(@).hasClass('mask') && !$(@).hasClass('full_mask') && !$(@).hasClass('html_calendarium')
                                if $(@).data('type') == 'mask'
                                    console.log 'mask'
                                else
                                    drop_target = $(@)
                        return

                    if drop_target
                        if drop_target.hasClass 'createNewPage'
                            $.ajax(
                              dataType: 'JSON'
                              method: 'POST'
                              data:
                                filename: element.data 'filename'
                                product_id: drop_target.data 'product_id'
                              url: '/ajax/app/create_multiproduct_page/'
                            ).done((data) ->
                                loadPage()
                                photoContainer.reload()
                                return
                            ).fail (jqXHR, textStatus) ->
                                console.warn 'Error: ' + jqXHR.responseText
                                return
    
                        else
                            console.log drop_target
                            if element.hasClass 'photo'
                                if $('#hide_used').prop('checked')
                                    element.parent().remove()

                            drop_coords =
                                x: drop_x
                                y: drop_y
                            input.afterDrop(drop_target, drop_coords)

                    dragged = false
                    # helper.remove()
                    element.attr 'dragged', false
                    element.css
                        left: 0
                        top: 0
                        opacity: 1
                        position: 'auto'

                    helper.css
                        left: 0
                        top: 0
                        opacity: 1
                        position: 'auto'

    }

    output.init()
    output.draggable()


    return output